'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dLogin$002dPage$002dView$0024$0024anon$002419 from "./presto.-Login-Page-View$$anon$19.js";
import * as $j_presto$002etypes$0024$002dAccount$002dId$0024 from "./presto.types$-Account-Id$.js";
import * as $j_presto$002etypes$0024$002dEmail$0024 from "./presto.types$-Email$.js";
import * as $j_presto$002etypes$0024$002dMorbid$002dUser$002dDetails$0024 from "./presto.types$-Morbid-User-Details$.js";
var $p;
/** @constructor */
function $c_Lpresto_LoginPageView$$anon$18() {
  this.b66 = null;
  this.b5Y = null;
  this.b5Z = false;
  this.b67 = null;
  this.b68 = false;
  this.b6b = null;
  this.b64 = null;
  this.b65 = false;
  this.b60 = null;
  this.b61 = false;
  this.b62 = null;
  this.b63 = false;
  this.b69 = false;
  this.b6a = false;
  this.b66 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.b6b = "MorbidUserDetails";
}
export { $c_Lpresto_LoginPageView$$anon$18 as $c_Lpresto_LoginPageView$$anon$18 };
$p = $c_Lpresto_LoginPageView$$anon$18.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_LoginPageView$$anon$18;
/** @constructor */
function $h_Lpresto_LoginPageView$$anon$18() {
}
export { $h_Lpresto_LoginPageView$$anon$18 as $h_Lpresto_LoginPageView$$anon$18 };
$h_Lpresto_LoginPageView$$anon$18.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.b66;
});
$p.L = (function() {
  if ((!this.b5Z)) {
    this.b5Y = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.b5Z = true;
  }
  return this.b5Y;
});
$p.O = (function() {
  if ((!this.b68)) {
    this.b67 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.b68 = true;
  }
  return this.b67;
});
$p.E = (function() {
  return this.b6b;
});
$p.t = (function() {
  if ((!this.b65)) {
    this.b64 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("email", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("account", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.b65 = true;
  }
  return this.b64;
});
$p.M = (function() {
  if ((!this.b61)) {
    this.b60 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dEmail$0024.$m_Lpresto_types$Email$().cG(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dAccount$002dId$0024.$m_Lpresto_types$AccountId$().bl(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.b61 = true;
  }
  return this.b60;
});
$p.Q = (function() {
  if ((!this.b63)) {
    this.b62 = new $j_presto$002e$002dLogin$002dPage$002dView$0024$0024anon$002419.$c_Lpresto_LoginPageView$$anon$19();
    this.b63 = true;
  }
  return this.b62;
});
$p.w = (function() {
  if ((!this.b6a)) {
    this.b69 = false;
    this.b6a = true;
  }
  return this.b69;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee126) => ((p) => \u03b4scrutinee126.GE(p)))($j_presto$002etypes$0024$002dMorbid$002dUser$002dDetails$0024.$m_Lpresto_types$MorbidUserDetails$())));
});
var $d_Lpresto_LoginPageView$$anon$18 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_LoginPageView$$anon$18, "presto.LoginPageView$$anon$18", ({
  M9: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_LoginPageView$$anon$18 as $d_Lpresto_LoginPageView$$anon$18 };
//# sourceMappingURL=presto.-Login-Page-View$$anon$18.js.map
